// extracted by mini-css-extract-plugin
export var active = "_fr-2";
export var recordingDot = "_fr-1";
export var recordingIndicator = "_fr-0";